import { get } from 'svelte/store'

import { apiProps } from '@/modules/api'
import { widgetOptions } from '@/modules/options'

import { availableLocales, DEFAULT_LOCALE } from './constants'
import type { AppLocale, TranslationData } from './types'

const translationFiles = import.meta.glob<TranslationData>('../../translates/*.json', { import: 'default' })

export const isAppLocale = (locale: string): locale is AppLocale => availableLocales.includes(locale as AppLocale)

export const resolveLocale = (locale: string): AppLocale => {
	return isAppLocale(locale) ? locale : DEFAULT_LOCALE
}

export const getLocale = (): AppLocale => {
	const { lang } = widgetOptions.getOptions()
	const { lang: language } = get(apiProps)
	return resolveLocale(language ?? lang)
}

const getTranslationFilePath = (locale: AppLocale) => `../../translates/${locale}.json`

export const loadTranslationFile = (locale: AppLocale): Promise<TranslationData> => {
	const load =
		translationFiles[getTranslationFilePath(locale)] ?? translationFiles[getTranslationFilePath(DEFAULT_LOCALE)]
	return load()
}

export const mergeTranslationData = (data: TranslationData, locale: AppLocale): TranslationData => {
	const { translates: customTranslations } = widgetOptions.getOptions()
	return { ...data, ...(customTranslations[locale] && customTranslations[locale]) }
}
